import { render } from "./Snackbar.vue?vue&type=template&id=2688baba&ts=true"
import script from "./Snackbar.vue?vue&type=script&lang=ts"
export * from "./Snackbar.vue?vue&type=script&lang=ts"

import "./Snackbar.vue?vue&type=style&index=0&id=2688baba&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__